module.exports = function() {
  return new Worker(__webpack_public_path__ + "9027069793b08f5e1bdc.worker.js");
};